import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import { callAPI } from "../../../../../App/Helpers/callApi";
import Signifier from "../../../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../../../App/State/Slices/SelectedCareersClientSlice";
import { editBingAccount, getBingAccount } from "./BingAccountService";

function BingAccountDetailed({ bingAccount, setBingAccount }) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    error: {
      color: theme.palette.error.main,
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [autoSuggest, setAutoSuggest] = useState(false);
  const [autoSuggestKey, setAutoSuggestKey] = useState("");
  const [mapSearch, setMapSearch] = useState(false);
  const [useMaps, setUseMaps] = useState(false);
  const [mapsKey, setMapsKey] = useState("");

  function saveBingAccount() {
    let data = {
      ClientId: selectCareersClient.id,
      HasBingAutoSuggest: autoSuggest,
      HasBingMapSearch: mapSearch,
      HasBingMaps: useMaps,
      BingAutoSuggestKey: autoSuggestKey,
      BingMapsKey: mapsKey,
    };

    callAPI(
      editBingAccount(data),
      "Bing Account Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getBingAccount(selectCareersClient.id).then((response) => {
        setBingAccount(response);
      });
    });
  }

  useEffect(() => {
    setAutoSuggest(bingAccount.hasBingAutoSuggest);
    setAutoSuggestKey(bingAccount.bingAutoSuggestKey);
    setMapSearch(bingAccount.hasBingMapSearch);
    setUseMaps(bingAccount.hasBingMaps);
    setMapsKey(bingAccount.bingMapsKey);
  }, [bingAccount]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className={classes.root}>
        <Grid className={classes.cardContainer}>
          <Card className={classes.card}>
            <CardContent>
              <Grid container spacing={1}>
                <Grid xs={12} sm={12} item>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={autoSuggest}
                        onChange={() => setAutoSuggest(!autoSuggest)}
                      />
                    }
                    label="Use AutoSuggest"
                  />
                </Grid>
                <Grid xs={12} sm={12} item>
                  <TextField
                    placeholder="AutoSuggest Key"
                    label="AutoSuggest Key"
                    variant="standard"
                    fullWidth
                    required
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={autoSuggestKey}
                    onChange={(e) => setAutoSuggestKey(e.target.value)}
                  />
                </Grid>
                <Grid xs={12} sm={6} item>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={mapSearch}
                        onChange={() => setMapSearch(!mapSearch)}
                      />
                    }
                    label="Use Map Search"
                  />
                </Grid>
                <Grid xs={12} sm={6} item>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={useMaps}
                        onChange={() => setUseMaps(!useMaps)}
                      />
                    }
                    label="Use Maps"
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    placeholder="Maps Key"
                    label="Maps Key"
                    variant="standard"
                    fullWidth
                    required
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={mapsKey}
                    onChange={(e) => setMapsKey(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} container justifyContent="flex-end">
                  <Button
                    style={{ marginTop: "20px", marginRight: "8px" }}
                    className={classes.sensitiveButton}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => saveBingAccount()}
                  >
                    Save Information
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </div>
    </>
  );
}

export default BingAccountDetailed;
